"use client";

import type { AddonDietAddonsRead } from "@repo/api/catalog/api/schemas/addon-diet-addons-read";
import { useEffect, useMemo } from "react";
import {
  buildAddonGtmListItems,
  slugifyAddonCategoryName,
} from "@/features/addons/lib/addon-gtm-item";
import { sendEvent } from "../gtm/event";

export type AddonListType = "addon-config" | "addon-modal";

type UseAddonViewItemListEventParams = {
  listType: AddonListType;
  // Category name exactly as the API returns it — never lowercased or slugified
  // (MPL-3731/3732).
  categoryName?: string;
  addons: AddonDietAddonsRead[];
  cateringName?: string;
  enabled: boolean;
};

export const useAddonViewItemListEvent = ({
  listType,
  categoryName,
  addons,
  cateringName,
  enabled,
}: UseAddonViewItemListEventParams) => {
  const items = useMemo(
    () => buildAddonGtmListItems({ addons, cateringName }),
    [addons, cateringName],
  );

  useEffect(() => {
    if (!(enabled && categoryName) || items.length === 0) {
      return;
    }

    sendEvent({
      event: "view_item_list",
      diet_type: listType,
      ecommerce: {
        item_list_name: `${listType}-${slugifyAddonCategoryName(categoryName)}`,
        items,
      },
    });
  }, [enabled, listType, categoryName, items]);
};
